import { render, staticRenderFns } from "./nav-list.html?vue&type=template&id=056ab7ca&scoped=true&external"
import script from "./nav-list.js?vue&type=script&lang=js&external"
export * from "./nav-list.js?vue&type=script&lang=js&external"
import style0 from "./nav-list.scss?vue&type=style&index=0&id=056ab7ca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ab7ca",
  null
  
)

export default component.exports